export const FB_PIXEL_ID = '1627789091219845';

export const initFacebookPixel = () => {
  // Check consent before loading
  const consent = localStorage.getItem('lucods_cookie_consent');
  if (consent === 'rejected') return;
  if (consent && consent !== 'accepted') {
    try {
      const prefs = JSON.parse(consent);
      if (!prefs.marketing) return;
    } catch {}
  }
  // Fix for 'fbq' is not defined and no-unused-expressions
  (function(f,b,e,v,n,t,s){
    if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)
  })(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');

  // Make sure to call fbq as a function, not as an expression
  window.fbq('init', '1627789091219845');
  window.fbq('track', 'PageView');
};
